import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import useQuery from './use-query';
import {useSettingsState} from '../components/settings';

const parseTags = (tagsArray) => {
    const result = {};
    if (!tagsArray?.length) return result;
    tagsArray.forEach(tag => {
        let [key, value] = tag.split(':');
        if (!value) [key, value] = tag.split('=');
        if (value) result[key] = value;
    });
    return result;
};

const useServiceLabels = () => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const {serviceById} = useLazyLoadQuery(
        graphql`
            query useServiceLabelsServiceByIdQuery($id: String) {
                serviceById(id: $id) {
                    id
                    version
                    description
                    tags
                    labels
                }
            }
        `,
        {id: serviceId}
    );
    const descriptionTags = serviceById.description ? serviceById.description.split(', ') : [];
    const tags = {...parseTags(descriptionTags), ...parseTags(serviceById.tags)};
    const labels = {...tags, ...(serviceById.labels || {})};
    
    return {
        labels
    }
};

export default useServiceLabels;

